import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { stagingURL } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const statisticsApi = createApi({
  reducerPath: "statisticsAPI",
  baseQuery: axiosBaseQuery({ baseUrl: stagingURL }),
  endpoints: () => ({}),
});
